import React, {Component} from 'react';
import { putToast, loadAdminConsole,  AuthenticatedUser, stopTimer, runService, hasPerm } from "../../api";
import {  List, HelpCircle, BarChart2 } from 'react-feather';
import BDBQueryCube from '../../pages/pageParts/bdbQueryCube';
import TournamentPageTemplate from './tournamentPageTemplate'

class TournamentAdmin extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;

        this.state = {
            loading: true,
            user: user,
            tData: {},
            pid: params.pid,
            buildBallotStatusColor: 'danger'
        }

    }
    
    loadTournamentPage = (pid) => {       
        if (this.state.pid) {
            loadAdminConsole(this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ pid: pid, tData: d2.tournamentPage, loading: false});                    
                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount() {
        this.loadTournamentPage();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.match.params.pid !== this.props.match.params.pid) {
            this.loadTournamentPage(this.props.match.params.pid);            
        }
    }

    onBuildBallotsClick() {
        var that=this;
        runService('buildBallots', 'start', '0', this.state.tData._id).then(service => {
            if (service && service.error) {
                console.log(service.error);
                putToast.error(service.error);
            } else {
                this.setState({buildBallotStatusColor: 'warning'});
            
                //function for tracking the status of the task
                function updateStatus(){
                    runService('buildBallots', 'check',  service._id, that.state.tData._id).then(response => {
                        if (response && response.error) {
                            console.log(response.error);
                            putToast.error(response.error);
                        } else {                            
                            if(response.status === 'Done!'){
                                that.setState({buildBallotStatusColor: 'success'});
                            } else {
                                setTimeout(updateStatus, 2000);
                            }
                        }
                    });
                }
                //start checking the task
                setTimeout(updateStatus, 2000);
            }
        });  
    }

    render(){
        if (this.state.loading) { return null; }
        else {
            stopTimer();      
            const { tData, user, buildBallotStatusColor } = this.state;
            var showAdmin = hasPerm(user, tData.permTags[0]);


            return (
                <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user} title2={`Administration - ${user.displayname}`} title3=""
                bcTitle="Admin Dashboard" bcParents={[{name: tData.title, url: `/pages/tournament/${tData._id}`}]} 
            >                  
                {showAdmin &&
             
                    <div className="container-fluid">
                        <div className="row">
                        {tData.judgeHelpPageId && 
                            <div className="col-xl-3 col-md-6 xl-50">
                                <BDBQueryCube title="Instructions" subtitle="Start here for information" qType="none" link={`/pages/lp/${tData.adminHelpPageId}`} icon={<HelpCircle className="font-success" />} bg="bg-success"/>
                            </div>
                        }   
                            <div className="col-xl-3 col-md-6 xl-50">
                                <BDBQueryCube title="Dashboard" subtitle="Stats and Charts" qType="none" link={`/tournament/admin/dashboard/${tData._id}`} icon={<BarChart2 className="font-info" />} bg="bg-info"/>
                            </div>     
                            <div className="col-xl-3 col-md-6 xl-50">
                                <BDBQueryCube title=" Messenger" subtitle="Send Messages" qType="none"  link={`/tournament/admin/messenger/${tData._id}`} icon={<List className="font-info" />} bg="bg-info"/>
                            </div> 
                            <div className="col-xl-3 col-md-6 xl-50">
                                <BDBQueryCube title=" Alerts" subtitle="Review Incoming Texts" qType="none"  link={`/tournament/admin/alerts/${tData._id}`} icon={<List className="font-info" />} bg="bg-info"/>
                            </div>                                                                                 
                        </div>
                        <div className="row">                    
                            <div className="col-xl-3 col-md-6 xl-50">
                                <BDBQueryCube title=" Tabulation" subtitle="Last Round Posted" qType="none" link={`/tournament/admin/postings/${tData._id}`} icon={<List className="font-danger"  />} bg="bg-danger" />
                            </div>                              
                            <div className="col-xl-3 col-md-6 xl-50">
                                    <BDBQueryCube title="Round/Event Assignments" subtitle="Override / Set Assignments" qType="none" link={`/tournament/admin/assignments/${tData._id}`} icon={<List className="font-danger" />} bg="bg-danger"/>
                            </div>  
                            <div className="col-xl-3 col-md-6 xl-50">
                                    <BDBQueryCube title=" Room Assignments " subtitle="Override / Set Assignments" qType="none" link={`/tournament/admin/roomjudges/${tData._id}`} icon={<List className="font-danger" />} bg="bg-danger"/>
                            </div>                              
                        </div>                      
                        <div className="row"> 
                            <div className="col-xl-3 col-md-6 xl-50">
                                <BDBQueryCube title=" Ballots" subtitle="All tournament ballots" qType="none" link={`/tournament/admin/ballots/${tData._id}`} icon={<List className="font-warning" />}  bg="bg-warning"/>
                            </div>                                                      
                            <div className="col-xl-3 col-md-6 xl-50">
                                <BDBQueryCube title=" Awards" subtitle="Winners list / award slides" qType="none" link={`/tournament/admin/awards/${tData._id}`} icon={<List className="font-warning" />} bg="bg-warning"/>
                            </div>                                                                                      
                            <div className="col-xl-3 col-md-6 xl-50">
                                <BDBQueryCube title=" Award Slides" subtitle="Present Certificates" qType="none" link={`/tournament/admin/awardslides/${tData._id}`} icon={<List className="font-warning" />} bg="bg-warning"/>
                            </div> 
                            <div className="col-xl-3 col-md-6 xl-50">
                                <span style={{cursor: 'pointer'}} onClick={() => this.onBuildBallotsClick() }>
                                    <BDBQueryCube title=" Build Ballots" subtitle="Build certs and ballots" qType="none" icon={<List className={`font-${buildBallotStatusColor}`} />} bg={`bg-${buildBallotStatusColor}`}/>
                                </span>
                            </div>   
                        </div>                      
                        <div className="row">  
                                                                                                        
                        </div>
                    </div>
                }
                </TournamentPageTemplate>
            )
        }
    }
}

export default TournamentAdmin;